const DEFAULT_VENUE_TIMEZONE = "Asia/Kolkata";

/** IANA timezone for turf “calendar days” (default Tuticorin / India). Override with `VITE_VENUE_TIMEZONE`. */
export function getVenueTimeZone(): string {
  return import.meta.env.VITE_VENUE_TIMEZONE || DEFAULT_VENUE_TIMEZONE;
}

/**
 * Calendar date in the venue timezone (YYYY-MM-DD), not the device’s local zone.
 * Uses the device clock for the instant, but maps that instant to the venue’s date.
 */
export function formatVenueDateYYYYMMDD(
  date: Date,
  timeZone: string = getVenueTimeZone()
): string {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);
  const y = parts.find((p) => p.type === "year")!.value;
  const m = parts.find((p) => p.type === "month")!.value;
  const d = parts.find((p) => p.type === "day")!.value;
  return `${y}-${m}-${d}`;
}

/** Add whole calendar days to a YYYY-MM-DD string (Gregorian; matches venue slot dates). */
export function addCalendarDaysYYYYMMDD(ymd: string, days: number): string {
  const [y, m, d] = ymd.split("-").map(Number);
  const t = new Date(Date.UTC(y, m - 1, d + days));
  const yy = t.getUTCFullYear();
  const mm = String(t.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(t.getUTCDate()).padStart(2, "0");
  return `${yy}-${mm}-${dd}`;
}
